import { MutationTree } from 'vuex';
import { State } from './state';

import { Mandant, Personaldaten } from '@/models/PersonaldatenModels';
import { Textbaustein, Vorlage, VorlageItem } from '@/models/VorlageModels';
import { PagedResult } from '@/models/CommonModels';

export enum MutationTypes {
  SetVorlagen = 'SETVORLAGEN',
  SetVorlageItems = 'SETVORLAGEITEMS',
  SetVorlagePageData = 'SETVORLAGEPAGEDATA',
  AddVorlage = 'ADDVORLAGE',
  AddOrUpdateVorlage = 'UPDATEVORLAGE',
  DeleteVorlage = 'DELETEVORLAGE',

  SetTextbausteine = 'SETTEXTBAUSTEINE',
  AddTextbaustein = 'ADDTEXTBAUSTEIN',
  AddOrUpdateTextbaustein = 'UPDATETEXTBAUSTEIN',
  DeleteTextbaustein = 'DELETETEXTBAUSTEIN',
}

export type Mutations = {
  [MutationTypes.SetVorlagen](state: State, data: Array<Vorlage>): void;
  [MutationTypes.SetVorlageItems](state: State, data: Array<VorlageItem>): void;
  [MutationTypes.SetVorlagePageData](state: State, data: PagedResult<VorlageItem>): void;
  [MutationTypes.AddVorlage](state: State, data: Vorlage): void;
  [MutationTypes.AddOrUpdateVorlage](state: State, data: Vorlage): void;
  [MutationTypes.DeleteVorlage](state: State, data: number): void;

  [MutationTypes.SetTextbausteine](state: State, data: Array<Textbaustein>): void;
  [MutationTypes.AddTextbaustein](state: State, data: Textbaustein): void;
  [MutationTypes.AddOrUpdateTextbaustein](state: State, data: Textbaustein): void;
  [MutationTypes.DeleteTextbaustein](state: State, data: number): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region Vorlagen
  [MutationTypes.SetVorlagen](state: State, data: Array<Vorlage>) {
    state.vorlagen = data;
    localStorage.setItem('vorlagen', JSON.stringify(state.vorlagen));
  },

  [MutationTypes.SetVorlageItems](state: State, data: Array<VorlageItem>) {
    state.vorlageItems = data;
    localStorage.setItem('vorlageItems', JSON.stringify(state.vorlageItems));
  },

  [MutationTypes.SetVorlagePageData](state: State, data: PagedResult<VorlageItem>) {
    state.vorlagePage = data;
  },

  [MutationTypes.AddVorlage](state: State, data: Vorlage) {
    state.vorlagen.push(data);
    localStorage.setItem('vorlagen', JSON.stringify(state.vorlagen));

    const newItem = {
      id: data.id,
      name: data.name,
      titel: data.titel,
      gruppe: data.gruppe,
      type: data.type,
    } as VorlageItem;

    state.vorlageItems.push(newItem);
    // state.vorlagePage.items.push(newItem);

    localStorage.setItem('vorlageItems', JSON.stringify(state.vorlageItems));
  },

  [MutationTypes.AddOrUpdateVorlage](state: State, data: Vorlage) {
    var index = state.vorlagen.findIndex((p) => p.id == data.id);
    if (index != -1) {
      state.vorlagen.splice(index, 1, data);
    } else {
      state.vorlagen.push(data);
    }

    localStorage.setItem('vorlagen', JSON.stringify(state.vorlagen));

    const newItem = {
      id: data.id,
      name: data.name,
      titel: data.titel,
      gruppe: data.gruppe,
      type: data.type,
    } as VorlageItem;

    const itemIndex = state.vorlageItems.findIndex((p) => p.id == data.id);
    if (itemIndex != -1) {
      state.vorlageItems.splice(itemIndex, 1, newItem);
    } else {
      state.vorlageItems.push(newItem);
    }

    localStorage.setItem('vorlageItems', JSON.stringify(state.vorlageItems));
  },

  [MutationTypes.DeleteVorlage](state: State, data: number) {
    var index = state.vorlagen.findIndex((p) => p.id == data);
    if (index != -1) {
      state.vorlagen.splice(index, 1);
    }

    localStorage.setItem('vorlagen', JSON.stringify(state.vorlagen));

    const itemIndex = state.vorlageItems.findIndex((p) => p.id == data);
    if (itemIndex != -1) {
      state.vorlageItems.splice(itemIndex, 1);
    }

    localStorage.setItem('vorlageItems', JSON.stringify(state.vorlageItems));
  },
  //#endregion

  //#region Textbausteine
  [MutationTypes.SetTextbausteine](state: State, data: Array<Textbaustein>) {
    state.textbausteine = data;
    localStorage.setItem('textbausteine', JSON.stringify(state.textbausteine));
  },

  [MutationTypes.AddTextbaustein](state: State, data: Textbaustein) {
    state.textbausteine.push(data);
    localStorage.setItem('textbausteine', JSON.stringify(state.textbausteine));
  },

  [MutationTypes.AddOrUpdateTextbaustein](state: State, data: Textbaustein) {
    var index = state.textbausteine.findIndex((p) => p.id == data.id);
    if (index != -1) {
      state.textbausteine.splice(index, 1, data);
    } else {
      state.textbausteine.push(data);
    }

    localStorage.setItem('textbausteine', JSON.stringify(state.textbausteine));
  },

  [MutationTypes.DeleteTextbaustein](state: State, data: number) {
    var index = state.textbausteine.findIndex((p) => p.id == data);
    if (index != -1) {
      state.textbausteine.splice(index, 1);
    }

    localStorage.setItem('textbausteine', JSON.stringify(state.textbausteine));
  },
  //#endregion
};
